module.exports = __webpack_public_path__ + "static/media/powerRidge.8c0a4fc6.svg";